import AxiosPrivateClient from "../../Clients/Axios/PrivateClient.mjs";
import V1 from "./v1/index.mjs";
import { PRICE_SERVICE_URL } from "../../node_modules/@stellantis-hub/constants/dist/constants.mjs";
const client = new AxiosPrivateClient({ baseURL: PRICE_SERVICE_URL });
const index = {
  v1: new V1(client)
};
export {
  index as default
};
